import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import book from './assets/Il-tasto-giusto-Caterina-Vivarelli.jpg';
import i1 from './assets/P1170120.jpeg';
import i2 from './assets/Lezioni_di_piano_Vivarelli.jpeg';
import { useTranslation } from 'react-i18next';

const Lezioni = ({ Banner }) => {
const { t } = useTranslation();

return (
    <>
    {Banner && <div>{Banner}</div>}
    <Container className='my-5'>
        <Row className='d-flex flex-column-reverse flex-md-row'>
        <Col xs={12} md={4} className='mb-3 mb-md-0 px-5 sticky-column'>
            {/* Image column */}
            <hr className='d-md-none'></hr>
            <img src={i2} alt="Image 1" className="img-fluid w-100 mb-4 mt-4 mt-md-0 d-block mx-auto" />
            <img src={i1} alt="Image 2" className="img-fluid w-100 d-block mx-auto" />
            {/* Add more images here */}
        </Col>
        <Col xs={12} md={8}>
            {/* Content column */}
            <h6 className='display-6 mb-3 fw-bold'>{t('techniques.breathing.title')}</h6>
            <p className='lead fw-normal' dangerouslySetInnerHTML={{ __html: t('techniques.breathing.description') }}></p>

            <h6 className='display-6 mb-3 mt-5 fw-bold'>{t('techniques.listening.title')}</h6>
            <p className='lead fw-normal' dangerouslySetInnerHTML={{ __html: t('techniques.listening.description') }}></p>

            <h6 className='display-6 mb-3 mt-5 fw-bold'>{t('techniques.separate_hands.title')}</h6>
            <p className='lead fw-normal' dangerouslySetInnerHTML={{ __html: t('techniques.separate_hands.description') }}></p>

            <h6 className='display-6 mb-3 mt-5 fw-bold'>{t('techniques.resetting.title')}</h6>
            <p className='lead fw-normal' dangerouslySetInnerHTML={{ __html: t('techniques.resetting.description') }}></p>

            <h6 className='display-6 mb-3 mt-5 fw-bold'>{t('techniques.micro_cell.title')}</h6>
            <p className='lead fw-normal' dangerouslySetInnerHTML={{ __html: t('techniques.micro_cell.description') }}></p>

            <h6 className='display-6 mb-3 mt-5 fw-bold'>{t('techniques.relay.title')}</h6>
            <p className='lead fw-normal' dangerouslySetInnerHTML={{ __html: t('techniques.relay.description') }}></p>

            <h6 className='display-6 mb-3 mt-5 fw-bold'>{t('techniques.musicians.title')}</h6>
            <p className='lead fw-normal' dangerouslySetInnerHTML={{ __html: t('techniques.musicians.description') }}></p>
        </Col>
        </Row>
    </Container>
    </>
);
};

export default Lezioni;